// test2793
(2793 && 0);
